import { render, staticRenderFns } from "./FileModule.vue?vue&type=template&id=1e6a740e"
import script from "./FileModule.vue?vue&type=script&lang=js"
export * from "./FileModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports